<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px">
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-text-field label="Código" v-model="tipo.id" readonly disabled outlined></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Descrição" v-model="tipo.descricao" outlined></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import Br from '@/config/barramento.js'
import metodos from '@/mixins/metodos'
// import { mapState } from 'vuex'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'tipo',
    mixins: [metodos],
    data(){
        return{
            cor: 'primary',
            mostrar: false,
            tipo: {},
        }
    },

    methods:{
        salvar(){
            const url = `${baseApiUrl}/Cadastros/tiposAtendimento/update.php`
					
					if(this.tipo.descricao){

						axios.post(url, this.tipo)
						.then(res => { 
							if(res.data.codigo == '01'){
                                showSuccess(res.data.mensagem)
                                Br.setTipoAtendimentoAtualizado(this.tipo)
                                this.tipo = {}
                                this.mostrar = false
							}else{
								showError(res.data.mensagem)
							}
						})
					}else{
						showError("Todos os campos devem ser preenchidos!")
					}
        },

        fechar(){
            this.mostrar = false
        }
    },

    created(){
    
        Br.onEditarTipoAtendimento(tipo => {
            this.tipo = tipo
            this.mostrar = true
        })
    },
}
</script>

<style scoped>

</style>